import React, { useState } from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { ButtonGroup, Button, Icon } from 'ui';
import LinkButton from 'components/shared/LinkButton';

const PublishConfirmationModal = ({ show, hideModal, handlePublish }) => {
  const [loading, setLoading] = useState(false);

  const initiatePublish = () => {
    setLoading(true);
    handlePublish();
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={hideModal}
        show={show}
      >
        <div className="ModalTakeover-container JourneyPublishModal">
          <div className="JourneyPublishModal-body">
            <form onSubmit={handlePublish}>
              <div className="JourneyPublishModal-title">
                {t('journeys.builder.publish_confirmation.heading')}
              </div>
              <div className="JourneyPublishModal-subtitle">
                {t('journeys.builder.publish_confirmation.body')}
              </div>
              <ButtonGroup alignEnd>
                <LinkButton
                  type="primary"
                  className="JourneyPublishModal-cancel"
                  onClick={hideModal}
                >
                  {t('common.cancel')}
                </LinkButton>
                <Button
                  primary
                  className="JourneyPublishModal-modal-publish"
                  loading={loading}
                  onClick={initiatePublish}
                >
                  {t('journeys.builder.publish')}
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={hideModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

// react_on_rails workaround to get hooks to work
export default props => <PublishConfirmationModal {...props} />;
